export const TAB_NOT_FOUND_STATUS: number = 400;

export const TAB_NOT_FOUND_MESSAGE: string = "PÁGINA NÃO ENCONTRADA";
